const React = require('react');
const ReactRedux = require('react-redux');

const actions = require('../../_actions.js');
const constants = require('../../constants/deployment.js');

function deployButton(props) {
	if (!props.display) {
		return null;
	}
	let btnText = 'Start deployment';
	let message = (
		<p className='alert alert-warning'>
			<i className="fa fa-warning" />
			Starting the deployment process takes effect immediately, ensure the details are entered correctly.
		</p>
	);
	if (props.queued) {
		message = null;
		btnText = 'Deployment started';
	}

	if (props.disabled_message) {
		message = (
			<p className='alert alert-warning'>
				<i className="fa fa-warning" />
				{props.disabled_message}
			</p>
		);
	}

	return (
		<div>
			{message}
			<button
				type="button"
				value="Confirm deployment"
				className="deploy"
				onClick={props.onClick}
				disabled={props.disabled}
			>
				{btnText}
			</button>
		</div>
	);
}

const mapStateToProps = function(state) {
	const current = state.deployment.list[state.deployment.current_id] || {};
	const deployment_in_progress = state.environment.deployment_in_progress;
	const isQueued = constants.isQueued(current.state);

	let disabled = false;
	let disabled_message = null;
	if (deployment_in_progress) {
		disabled = true;
		disabled_message = (
			<span>
				Deployment unavailable: there is <a href={deployment_in_progress}>a deployment already in progress</a> on this environment. 
			</span>
		);
	}

	if (isQueued) {
		disabled = true;
	}

	return {
		disabled: disabled,
		disabled_message: disabled_message,
		display: constants.canDeploy(state) && !state.deployment.is_queuing
	};
};

const mapDispatchToProps = function(dispatch, ownProps) {
	return {
		onClick: function() {
			dispatch(actions.startDeploy(ownProps.sha));
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(deployButton);
